<header class="header-slim">
  <div class="header-slim__logo">
    <img [src]="clientTheme.logoSmallUri" alt="Rocket Close Clear Sign Logo"/>
  </div>
  <ng-content></ng-content>
</header>
